<template>
  <div class="lg:px-20 md:px-12 px-5 lg:py-16 md:py-12 py-8 bg-primary landing">
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="break-normal">
        <h3
          class="fsize20 sm-fsize16 cust-textColor mt-2 lg:mb-3 md:mb-3 mb-2 font-medium"
        >
          <!-- Transformative Impact -->
          {{ selectedpopup.heading }}
        </h3>

        <p class="fsize16 sm-fsize14">
          {{ selectedpopup.description }}
        </p>
      </div>
    </el-dialog>
    <div class="container mx-auto">
      <div
        class="lg:w-1/2 md:w-5/6 w-full mx-auto text-center lg:mb-16 md:mb-12 mb-8"
      >
        <h2 class="font-semibold fsize30 sm-fsize20 clr-fff">
          The Impact Of Making Your Organization A Future Fit Corporate
        </h2>
      </div>

      <swiper :options="swiperOption" class="mySwiper">
        <swiper-slide
          class="bg-white p-6 rounded-lg fix-h"
          v-for="(item, index) in ffc_review.result"
          :key="index"
        >
          <div class="">
            <feather-icon
              icon="HeartIcon"
              class="clr-786ACE"
              svgClasses="w-5 h-5 ml-1"
            ></feather-icon>
          </div>

          <div class="" >
            <h3
              class="fsize20 sm-fsize16 cust-textColor mt-2 lg:mb-3 md:mb-3 mb-2 font-medium"
            >
              <!-- Transformative Impact -->
              {{ item.heading }}
            </h3>

            <p class="fsize16 sm-fsize14 lineclamp-3 cursor-pointer" @click="handlepopup(item)">
              {{ item.description }}
            </p>
          </div>
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  data() {
    return {
      selectedpopup: "",
      dialogVisible: false,
      swiperOption: {
        slidesPerView: 6,
        spaceBetween: 30,
        breakpoints: {
          1600: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1300: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          900: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          820: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        observer: true,
        observeParents: true,
      },

      openAddBannerSidebar: false,
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  // data() {
  //   return {
      
  //   };
  // },
  methods: {
    async handlepopup(value) {
      console.log(value)
      
      this.selectedpopup = value;
      this.dialogVisible = true;
    },
    async dataLoad() {
      let payload = {
        search: this.search,
        limit: 10,
        offset: (this.currentPage - 1) * 10,
      };
      let data = await this.$store.dispatch("ffc/get_review", payload);
      this.totalPages = data.data.totalCount;
    },
  },
  computed: {
    ...mapState("ffc", {
      ffc_review: "ffc_review",
    }),
  },
  mounted() {
    this.dataLoad();
  },
};
</script>
<style>
.bg-41193d {
  background: #41193d;
}
.fsize30 {
  font-size: 30px;
}
.landing .swiper-button-next {
  border-radius: 100% !important;
  background-size: 57px !important;
  width: 36px !important;
  height: 27px !important;
  background-size: 57px 52px !important;

  background-repeat: no-repeat !important;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-pack: center !important;
  -ms-flex-pack: center !important;
  justify-content: center !important;
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
}
.landing .swiper-button-prev {
  border-radius: 100% !important;
  background-size: 57px !important;
  width: 36px !important;
  height: 27px !important;
  background-size: 57px 52px !important;

  background-repeat: no-repeat !important;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-pack: center !important;
  -ms-flex-pack: center !important;
  justify-content: center !important;
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
  font-size: 18px !important;
}

.fix-h.swiper-slide {
  height: 202px;
  @media (max-width: 640px) {
    height: 180px !important;
  }
}
.el-dialog__header{
  padding: 0;
}
</style>
